module.exports = __webpack_public_path__ + "static/kitchen-7caf694de1340dd8207ad368386a8890.jpg";